var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notice"},[(_vm.href && _vm.href.startsWith('/'))?_c('router-link',{staticClass:"notice-content",attrs:{"to":_vm.href}},[_vm._t("default")],2):_c('div',{staticClass:"notice-content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }